import { makeStyles } from "@material-ui/core";

export const useSelectionStyles = makeStyles((theme) => ({
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      width: 200,
    },
    formControl: {
      marginRight: theme.spacing(1),
    },
    select: {
        height: '40px',
        lineHeight: 'normal',
    },
    menuItem: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    colorCircle: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      marginRight: '10px',
      cursor: 'pointer',
    },
  }))